// extracted by mini-css-extract-plugin
module.exports = {"container":"tabBar__container___2jFFq"};